import * as devisConf from '@/configuration/devisConf';

export default function creerIntervenant(client) {
  const intervenant = {
    nomCommercial: client.nomCommercial,
    adressePostale: client.adressePostale,
    modeReglementId: client.modeReglementId,
    modeReglement: client.modeReglement,
    delaiReglementId: client.delaiReglementId,
    delaiReglement: client.delaiReglement,
    delaiReglementDetail: client.delaiReglementDetail,
    siret: client.siret,
    tvaIntracommunautaire: client.tvaIntracommunautaire,
    tiersId: client.id,
    payeur: false,
    donneurOrdre: false,
    mandataire: false,
    annonceur: false,
    repartition: null,
    titre: null,
    typeRepartition: devisConf.POURCENTAGE,
    tiers: {
      id: client.id,
      nombreMoisPreavis: client.nombreMoisPreavis,
      modeCalculHonoraire: client.modeCalculHonoraire,
      typologie: client.typologie,
      tiersParentId: client.tiersParentId,
      prospect: client.prospect,
      blocageLevel: client.blocageLevel,
      contacts: client.contacts,
    },
    role: client.role,
    compteComptable: client.compteComptable,
    factureParMail: client.factureParMail,
    applicationTva: client.applicationTva,
    nvClient: false,
  };
  if (client.contacts?.length > 0) {
    intervenant.contact = client.contacts[0];
    intervenant.contactId = client.contacts[0].id;
  }
  if (client.contacts?.length === 1) {
    intervenant.intervenantContacts = [{
      contactId: client.contacts[0]?.id,
      contact: client.contacts[0],
      contactTypes: client.contacts[0]?.typesContactIds
        .map(tc => { return { typeContactId: tc }; }) ?? [],
    }];
  } else {
    intervenant.intervenantContacts = [];
  }
  return intervenant;
}
